import axios from 'axios'
import store from '@/store'
import { getApiUrl } from '@/helper'

const baseURL = getApiUrl()

const axiosInstance = axios.create({
  baseURL,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json'
  },
  withCredentials: true,
  exposedHeaders: ['set-cookie']
})

axiosInstance.interceptors.response.use((response) => {
    if (!store.getters['user/isAuth'] && window.location.pathname !== '/auth') {
      store.commit('user/clearState')
      localStorage.clear()
      window.location.href = '/auth'

      return {
        data: {
          code: 400,
          data: {
            data: {
              message: 'Отсутствует авторизация'
            }
          }
        }
      }
    }

    return response
  }, (error) => {
    const { status } = error.response || {}

    if (status === 401) {
      store.commit('user/clearState')
      localStorage.clear()

      if (window.location.pathname !== '/auth') {
        window.location.href = '/auth'
      }
    }

    if (error.response) {
      return error.response
    }

    const message = 'Не удалось связаться с сервером. Проверьте соединение и попробуйте снова.'

    return {
      data: {
        code: error.code || 'NETWORK_ERROR',
        data: {
          message,
          data: { message }
        }
      }
    }
  }
)

export default axiosInstance
